export function tickAnimation(inlineCells, artistContainers) {
	for (const cell of inlineCells) {
		if (cell.frames.length === 0) {
			cell.pathEl.setAttribute('d', '');
			continue;
		}
		cell.frameIndex = (cell.frameIndex + 1) % cell.frames.length;
		cell.pathEl.setAttribute('d', cell.frames[cell.frameIndex]);
	}

	for (const container of artistContainers) {
		if (!container.isVisible) {
			continue;
		}
		for (const cell of container.cells) {
			if (cell.frames.length === 0) {
				cell.pathEl.setAttribute('d', '');
				continue;
			}
			cell.frameIndex = (cell.frameIndex + 1) % cell.frames.length;
			cell.pathEl.setAttribute('d', cell.frames[cell.frameIndex]);
		}
	}
}

export function startAnimationLoop(tick, interval = 130) {
	return setInterval(tick, interval);
}
